'use strict';

module.exports = {
    /**
     * 关闭当前窗口<br />
     * 对应native接口：webview.back
     * @method hysdk.closeWindow
     * @category Window
     * @example ./closeWindow.js[1-3]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   √   |
     *
     */
    closeWindow: {
        hy: {
            key: 'webview.back'
        },
        wechat: {
            key: 'closeWindow'
        }
    },
    /**
     * 隐藏右上角菜单（当前版本效果和 hideAllNonBaseMenuItem 相同）<br />
     * 对应native接口：hideOptionMenu
     * @method hysdk.hideOptionMenu
     * @category Window
     * @example ./hideOptionMenu.js[1-3]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   X   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    hideOptionMenu: {
        hy: {
            key: 'hideOptionMenu'
        },
        wechat: {
            key: 'hideOptionMenu'
        }
    },
    /**
     * 显示右上角菜单（当前版本效果和 showAllNonBaseMenuItem 相同）<br />
     * 对应native接口：showOptionMenu
     * @method hysdk.showOptionMenu
     * @category Window
     * @example ./showOptionMenu.js[1-3]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   X   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    showOptionMenu: {
        hy: {
            key: 'showOptionMenu'
        },
        wechat: {
            key: 'showOptionMenu'
        }
    },
    /**
     * 批量隐藏功能按钮<br />
     * 对应native接口：hideMenuItems
     * @method hysdk.hideMenuItems
     * @category Window
     * @example ./hideMenuItems.js[1-5]
     * @description
     * 基本类
     *
     * * 举报: "menuItem:exposeArticle"
     * * 调整字体: "menuItem:setFont"
     * * 日间模式: "menuItem:dayMode"
     * * 夜间模式: "menuItem:nightMode"
     * * 刷新: "menuItem:refresh"
     * * 查看公众号（已添加）: "menuItem:profile"
     * * 查看公众号（未添加）: "menuItem:addContact"
     *
     * 传播类
     *
     * * 发送给朋友: "menuItem:share:appMessage"
     * * 分享到朋友圈: "menuItem:share:timeline"
     * * 分享到QQ: "menuItem:share:qq"
     * * 分享到Weibo: "menuItem:share:weiboApp"
     * * 收藏: "menuItem:favorite"
     * * 分享到FB: "menuItem:share:facebook"
     *
     * 保护类
     *
     * * 调试: "menuItem:jsDebug"
     * * 编辑标签: "menuItem:editTag"
     * * 删除: "menuItem:delete"
     * * 复制链接: "menuItem:copyUrl"
     * * 原网页: "menuItem:originPage"
     * * 阅读模式: "menuItem:readMode"
     * * 在QQ浏览器中打开: "menuItem:openWithQQBrowser"
     * * 在Safari中打开: "menuItem:openWithSafari"
     * * 邮件: "menuItem:share:email"
     * * 一些特殊公众号: "menuItem:share:brand"
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   X   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    hideMenuItems: {
        hy: {
            key: 'hideMenuItems'
        },
        wechat: {
            key: 'hideMenuItems'
        }
    },
    /**
     * 批量显示功能按钮接口<br />
     * 对应native接口：showMenuItems
     * @method hysdk.showMenuItems
     * @category Window
     * @example ./showMenuItems.js[1-5]
     * @description
     *
     * 菜单列表如 hideMenuItems
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   X   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    showMenuItems: {
        hy: {
            key: 'showMenuItems'
        },
        wechat: {
            key: 'showMenuItems'
        }
    },
    /**
     * 隐藏所有非基础按钮<br />
     * 对应native接口：hideAllNonBaseMenuItem
     * @method hysdk.hideAllNonBaseMenuItem
     * @category Window
     * @example ./hideAllNonBaseMenuItem.js[1-3]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   X   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    hideAllNonBaseMenuItem: {
        hy: {
            key: 'hideAllNonBaseMenuItem'
        },
        wechat: {
            key: 'hideAllNonBaseMenuItem'
        }
    },
    /**
     * 显示所有功能按钮<br />
     * 对应native接口：showAllNonBaseMenuItem
     * @method hysdk.showAllNonBaseMenuItem
     * @category Window
     * @example ./showAllNonBaseMenuItem.js[1-6]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   X   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    showAllNonBaseMenuItem: {
        hy: {
            key: 'showAllNonBaseMenuItem'
        },
        wechat: {
            key: 'showAllNonBaseMenuItem'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/window.js
// module id = 20
// module chunks = 0 2 4